import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { FileText } from 'lucide-react'
import { TemplateList } from '@/components/shared/TemplateList'

type Template = { id: string; name: string; file_url: string | null }

type Props = {
  license: { id: string; display_name: string; business_name: string }
  templates: Template[]
}

export default function DocumentsShow({ license, templates }: Props) {
  return (
    <DashboardLayout
      title={`Documents — ${license.display_name}`}
      breadcrumbs={[
        { label: 'Licenses', href: 'licenses' },
        { label: license.display_name, href: `licenses/${license.id}` },
        { label: 'Documents' }
      ]}
    >
      <div>
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <FileText className="w-4 h-4 text-muted-foreground" />
            <h1 className="text-xl font-semibold tracking-tight">Documents</h1>
          </div>
          <p className="text-sm text-muted-foreground">{license.display_name}</p>
        </div>

        <div className="space-y-6">
          <TemplateList title="Document Templates" templates={templates || []} />
        </div>
      </div>
    </DashboardLayout>
  )
}
